import get from 'lodash/get';

export const CollegialOrganization = (item) => ({
  id: get(item, 'id') || '',
  name: get(item, 'name') || '',
  description: get(item, 'description') || '',
  organing: get(item, 'organing') || ''
});